/*
 * Listicle Black Week (lbw-*). Vanilla JS, inga bibliotek.
 * Varje del letar upp sina element via data-attribut, initieras på DOMContentLoaded och
 * igen på shopify:section:load (temaeditorn), och städar på shopify:section:unload.
 */
(function () {
  if (window.LBW_LOADED) return;
  window.LBW_LOADED = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var cleanups = new Map();

  function addCleanup(el, fn) {
    var list = cleanups.get(el) || [];
    list.push(fn);
    cleanups.set(el, list);
  }

  function cleanupWithin(scope) {
    cleanups.forEach(function (list, el) {
      if (scope === document || scope === el || scope.contains(el)) {
        list.forEach(function (fn) { fn(); });
        cleanups.delete(el);
      }
    });
  }

  function each(scope, selector, fn) {
    if (scope !== document && scope.matches && scope.matches(selector)) fn(scope);
    scope.querySelectorAll(selector).forEach(fn);
  }

  function scrollBehavior() {
    return reducedMotion.matches ? 'auto' : 'smooth';
  }

  /* ---------- 1. Kampanjslut ---------- */

  // Förskjutningen (ms) mellan UTC och tidszonen vid tidpunkten t.
  function zoneOffset(t, timeZone) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(new Date(t)).forEach(function (p) { parts[p.type] = p.value; });
    var asUtc = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
    return asUtc - Math.floor(t / 1000) * 1000;
  }

  // "2026-12-01T23:59" i lokal tid för timeZone → UTC-millisekunder. Sommartid hanteras.
  function zonedToUtc(local, timeZone) {
    var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(local);
    if (!m) return null;
    var y = +m[1], mo = +m[2] - 1, d = +m[3], h = +m[4], mi = +m[5], s = +(m[6] || 0);
    var guess = Date.UTC(y, mo, d, h, mi, s);
    var check = new Date(guess);
    if (check.getUTCFullYear() !== y || check.getUTCMonth() !== mo || check.getUTCDate() !== d ||
        check.getUTCHours() !== h || check.getUTCMinutes() !== mi) return null;
    try {
      var offset = zoneOffset(guess, timeZone);
      var t = guess - offset;
      var corrected = zoneOffset(t, timeZone);
      return corrected === offset ? t : guess - corrected;
    } catch (e) {
      return null;
    }
  }

  function readCampaign() {
    var el = document.querySelector('[data-lbw-campaign]');
    if (!el) return null;
    var raw = el.getAttribute('data-end');
    if (!raw) return null;
    var end;
    if (el.hasAttribute('data-tz')) {
      end = zonedToUtc(raw, el.getAttribute('data-tz'));
    } else {
      // Liquid ger "+0100", som Safari inte tolkar: gör om till "+01:00".
      end = Date.parse(raw.replace(/([+-]\d\d)(\d\d)$/, '$1:$2'));
    }
    if (end === null || isNaN(end)) return null;
    return {
      end: end,
      hideEnded: el.getAttribute('data-hide-ended') !== 'false',
      endedText: el.getAttribute('data-ended-text') || '',
      units: {
        days: el.getAttribute('data-unit-days') || 'D',
        hours: el.getAttribute('data-unit-hours') || 'H',
        minutes: el.getAttribute('data-unit-minutes') || 'MIN'
      }
    };
  }

  /* ---------- 2. Nedräkning ---------- */

  var countdownTimer = null;

  // Hela minuter som återstår, aldrig 0 (sista minuten visas som 1 MIN).
  function formatRemaining(ms, units) {
    var totalMinutes = Math.max(1, Math.floor(ms / 60000));
    var days = Math.floor(totalMinutes / 1440);
    var hours = Math.floor((totalMinutes % 1440) / 60);
    var minutes = totalMinutes % 60;
    if (totalMinutes < 60) return minutes + ' ' + units.minutes;
    if (totalMinutes < 1440) return hours + ' ' + units.hours + ' ' + minutes + ' ' + units.minutes;
    return days + ' ' + units.days + ' ' + hours + ' ' + units.hours + ' ' + minutes + ' ' + units.minutes;
  }

  // Stickyns undertext med nedräkning: "2d 14h 32m", under 24 h "14h 32m", under 1 h "32m".
  function formatSticky(ms) {
    var totalMinutes = Math.max(1, Math.floor(ms / 60000));
    var days = Math.floor(totalMinutes / 1440);
    var hours = ('0' + Math.floor((totalMinutes % 1440) / 60)).slice(-2);
    var minutes = ('0' + (totalMinutes % 60)).slice(-2);
    if (totalMinutes < 60) return minutes + 'm';
    if (totalMinutes < 1440) return hours + 'h ' + minutes + 'm';
    return days + 'd ' + hours + 'h ' + minutes + 'm';
  }

  function renderStickyCountdowns(campaign, remaining) {
    document.querySelectorAll('[data-lbw-sticky-countdown]').forEach(function (el) {
      if (campaign && remaining > 0) {
        el.textContent = formatSticky(remaining);
        el.hidden = false;
      } else {
        var fallback = el.getAttribute('data-fallback') || '';
        el.textContent = fallback;
        el.hidden = !fallback;
      }
    });
  }

  function renderCountdowns() {
    clearTimeout(countdownTimer);
    var rows = document.querySelectorAll('[data-lbw-countdown]');
    var stickyRows = document.querySelectorAll('[data-lbw-sticky-countdown]');
    if (!rows.length && !stickyRows.length) return;
    var campaign = readCampaign();
    var remaining = campaign ? campaign.end - Date.now() : 0;
    renderStickyCountdowns(campaign, remaining);

    rows.forEach(function (row) {
      var label = row.querySelector('.lbw-countdown__label');
      var time = row.querySelector('.lbw-countdown__time');
      row.classList.remove('is-ended');
      if (label) label.hidden = false;

      if (!campaign) {
        row.hidden = true;
      } else if (remaining > 0) {
        time.textContent = formatRemaining(remaining, campaign.units);
        row.hidden = false;
      } else if (!campaign.hideEnded && campaign.endedText) {
        row.classList.add('is-ended');
        if (label) label.hidden = true;
        time.textContent = campaign.endedText;
        row.hidden = false;
      } else {
        row.hidden = true;
      }
    });

    // Var 30:e sekund, och exakt vid slutet så att raden försvinner direkt.
    if (campaign && remaining > 0) {
      countdownTimer = setTimeout(renderCountdowns, Math.min(30000, remaining + 50));
    }
  }

  /* ---------- 3. Färgväljaren i köpblocket ---------- */

  // Samma platshållare som i Liquid: [jämförpris], [besparing], [procent].
  function fillTemplate(template, values) {
    return (template || '').replace(/\[([^\]]+)\]/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function initOffer(root) {
    var dataEl = root.querySelector('[data-lbw-product]');
    if (!dataEl) return;
    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var image = root.querySelector('[data-lbw-offer-image] img');
    var colorValue = root.querySelector('[data-lbw-color-value]');
    var price = root.querySelector('[data-lbw-price]');
    var valueLine = root.querySelector('[data-lbw-value-line]');
    var savingTag = root.querySelector('[data-lbw-saving-tag]');
    var discountBadge = root.querySelector('[data-lbw-discount-badge]');
    var cta = root.querySelector('[data-lbw-cta-auto]');
    var giftImages = root.querySelectorAll('[data-lbw-gift-colors]');
    var swatches = root.querySelectorAll('[data-lbw-swatch]');

    function variantFor(key) {
      var available = null;
      var first = null;
      variants.forEach(function (v) {
        if (v.key !== key) return;
        if (!first) first = v;
        if (!available && v.available) available = v;
      });
      return available || first;
    }

    function select(key) {
      var v = variantFor(key);
      if (!v) return;

      swatches.forEach(function (s) {
        s.setAttribute('aria-pressed', s.getAttribute('data-lbw-swatch') === key ? 'true' : 'false');
      });
      if (colorValue) colorValue.textContent = v.color;

      if (image && v.img) {
        image.src = v.img;
        if (v.srcset) image.srcset = v.srcset; else image.removeAttribute('srcset');
        image.alt = v.alt || '';
      }

      var values = { 'jämförpris': v.compare, besparing: v.saving, procent: v.pct };
      if (price) price.textContent = v.price;
      if (valueLine) {
        valueLine.textContent = fillTemplate(valueLine.getAttribute('data-template'), values);
        valueLine.hidden = !v.compare;
      }
      [savingTag, discountBadge].forEach(function (el) {
        if (!el) return;
        el.textContent = fillTemplate(el.getAttribute('data-template'), values);
        el.hidden = v.pct < 5;
      });
      if (cta) cta.href = v.url;

      // Gåvobilder som följer färgen: {"black": "url", …} på bildrutan.
      giftImages.forEach(function (thumb) {
        var img = thumb.querySelector('img');
        var map;
        try {
          map = JSON.parse(thumb.getAttribute('data-lbw-gift-colors'));
        } catch (e) {
          return;
        }
        var src = map[key] || thumb.getAttribute('data-default-src');
        if (img && src) {
          img.src = src;
          img.removeAttribute('srcset');
        }
      });
    }

    function onClick(event) {
      var swatch = event.target.closest('[data-lbw-swatch]');
      if (!swatch || swatch.disabled || !root.contains(swatch)) return;
      select(swatch.getAttribute('data-lbw-swatch'));
    }

    root.addEventListener('click', onClick);
    addCleanup(root, function () { root.removeEventListener('click', onClick); });
  }

  /* ---------- 4. Chips i Black Week-erbjudanden ---------- */

  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    var more = root.querySelector('[data-lbw-show-all]');

    function activate(tab, focus) {
      tabs.forEach(function (t) {
        var selected = t === tab;
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        t.tabIndex = selected ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      if (more) {
        var url = tab.getAttribute('data-url');
        if (url) more.href = url;
        more.hidden = !url;
      }
      if (focus) tab.focus();
    }

    function onClick(event) {
      var tab = event.target.closest('[role="tab"]');
      if (tab && root.contains(tab)) activate(tab, false);
    }

    function onKeydown(event) {
      var index = tabs.indexOf(event.target);
      if (index === -1) return;
      var next = null;
      if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
      else if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
      else if (event.key === 'Home') next = tabs[0];
      else if (event.key === 'End') next = tabs[tabs.length - 1];
      if (!next) return;
      event.preventDefault();
      activate(next, true);
    }

    root.addEventListener('click', onClick);
    root.addEventListener('keydown', onKeydown);
    addCleanup(root, function () {
      root.removeEventListener('click', onClick);
      root.removeEventListener('keydown', onKeydown);
    });
  }

  /* ---------- 5. Sticky köpbar ---------- */

  function initSticky(bar) {
    var devices = bar.getAttribute('data-devices');
    var showAfter = bar.getAttribute('data-show-after');
    var showAfterPx = parseInt(bar.getAttribute('data-show-after-px'), 10) || 0;
    var hideOverSections = bar.getAttribute('data-hide-over-sections') !== 'false';
    var button = bar.querySelector('[data-lbw-sticky-button]');
    var mobileQuery = window.matchMedia('(max-width: 1023.98px)');
    var hero = document.querySelector('[data-lbw-hero]');

    var conditionMet = showAfter === 'immediately' || (showAfter === 'hero' && !hero);
    var covering = new Set();
    var observers = [];
    var visible = false;
    var frame = null;

    function update() {
      var deviceOk = devices === 'all' || mobileQuery.matches;
      var show = deviceOk && conditionMet && covering.size === 0;
      if (show === visible) return;
      visible = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.inert = !show;
      document.body.style.paddingBottom = show ? bar.offsetHeight + 'px' : '';
    }

    if (showAfter === 'hero' && hero) {
      var heroObserver = new IntersectionObserver(function (entries) {
        conditionMet = !entries[0].isIntersecting;
        update();
      }, { threshold: 0 });
      heroObserver.observe(hero);
      observers.push(heroObserver);
    }

    function onScroll() {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        conditionMet = window.scrollY >= showAfterPx;
        update();
      });
    }
    if (showAfter === 'pixels') {
      conditionMet = window.scrollY >= showAfterPx;
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    if (hideOverSections) {
      var hideObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) covering.add(entry.target);
          else covering.delete(entry.target);
        });
        update();
      }, { rootMargin: '0px 0px -80px 0px', threshold: 0 });
      document.querySelectorAll('[data-lbw-hide-sticky]').forEach(function (el) { hideObserver.observe(el); });
      observers.push(hideObserver);
    }

    mobileQuery.addEventListener('change', update);

    // Tomt mål: närmaste köpblock nedanför, annars griden nedanför, annars närmaste köpblock ovanför.
    function autoTarget() {
      var limit = window.innerHeight - bar.offsetHeight;
      var offers = Array.prototype.slice.call(document.querySelectorAll('[data-lbw-offer]'));
      var below = offers.filter(function (o) { return o.getBoundingClientRect().top >= limit; });
      if (below.length) return below[0];
      var grid = document.querySelector('[data-lbw-grid]');
      if (grid && grid.getBoundingClientRect().top >= limit) return grid;
      var above = offers.filter(function (o) { return o.getBoundingClientRect().top < limit; });
      return above.length ? above[above.length - 1] : grid;
    }

    function onButtonClick(event) {
      var targetId = button.getAttribute('data-target-id');
      if (button.hasAttribute('data-target-url')) return;
      var target = targetId ? document.getElementById(targetId) : null;
      if (!target) target = autoTarget();
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
    }
    if (button) button.addEventListener('click', onButtonClick);

    update();

    addCleanup(bar, function () {
      observers.forEach(function (o) { o.disconnect(); });
      window.removeEventListener('scroll', onScroll);
      mobileQuery.removeEventListener('change', update);
      if (button) button.removeEventListener('click', onButtonClick);
      if (frame) cancelAnimationFrame(frame);
      if (visible) document.body.style.paddingBottom = '';
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
      bar.inert = true;
    });
  }

  /* ---------- 6. Video ---------- */

  // Videon renderas utan autoplay. Utan minskad rörelse startas den tyst i loop, annars får
  // besökaren kontroller och startar själv.
  function initVideo(video) {
    if (reducedMotion.matches) {
      video.controls = true;
      return;
    }
    video.muted = true;
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {});
  }

  /* ---------- Start och temaeditorn ---------- */

  // Ett fel i en del (t.ex. en gammal webbläsare) får inte stoppa de andra.
  function safely(fn, el) {
    try {
      fn(el);
    } catch (e) {
      if (window.console) console.error('lbw:', e);
    }
  }

  function initSection(scope) {
    each(scope, '[data-lbw-offer]', function (el) { safely(initOffer, el); });
    each(scope, '[data-lbw-tabs]', function (el) { safely(initTabs, el); });
    each(scope, 'video[data-lbw-video]', function (el) { safely(initVideo, el); });
  }

  // Sticky och nedräkning läser hela sidan, så de startas om när en sektion ändras.
  function initPage() {
    // Städa delar vars sektion redan har tagits bort ur sidan.
    cleanups.forEach(function (list, el) {
      if (el.isConnected) return;
      list.forEach(function (fn) { fn(); });
      cleanups.delete(el);
    });
    renderCountdowns();
    document.querySelectorAll('[data-lbw-sticky]').forEach(function (bar) {
      cleanupWithin(bar);
      safely(initSticky, bar);
    });
  }

  function start() {
    initSection(document);
    initPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target);
    initPage();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    cleanupWithin(event.target);
    // Sektionen tas bort efter händelsen: vänta en tick och läs om sidan.
    setTimeout(initPage, 0);
  });
})();
